// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Event = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Event.bs.js");
var Webapi__Dom__DragEvent = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__DragEvent.bs.js");
var Webapi__Dom__FocusEvent = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__FocusEvent.bs.js");
var Webapi__Dom__InputEvent = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__InputEvent.bs.js");
var Webapi__Dom__MouseEvent = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__MouseEvent.bs.js");
var Webapi__Dom__WheelEvent = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__WheelEvent.bs.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var Webapi__Dom__KeyboardEvent = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__KeyboardEvent.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var Webapi__Dom__ClipboardEvent = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__ClipboardEvent.bs.js");
var DOM__EventType$SmartcutsMacros = require("./DOM__EventType.bs.js");
var DOM__DataTransfer$SmartcutsMacros = require("./DOM__DataTransfer.bs.js");

function t_encode(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["Document"];
    } else {
      return ["Window"];
    }
  } else {
    return [
            "Element",
            Selector$SmartcutsMacros.selector_encode(v._0)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Document" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Document */1
                  };
          }
      case "Element" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* Element */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Window" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Window */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function fromDomEventTarget(target) {
  if (window === target) {
    return /* Window */0;
  } else if (document === target) {
    return /* Document */1;
  } else {
    return /* Element */{
            _0: Selector$SmartcutsMacros.forDomEventTarget(target)
          };
  }
}

function stringify(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return "Document";
    } else {
      return "Window";
    }
  } else {
    return "Element(" + (Selector$SmartcutsMacros.stringify(undefined, false, v._0) + ")");
  }
}

var EventTargetForSerialization = {
  t_encode: t_encode,
  t_decode: t_decode,
  fromDomEventTarget: fromDomEventTarget,
  stringify: stringify
};

function eventPhase_encode(v) {
  switch (v) {
    case /* None */0 :
        return ["None"];
    case /* CapturingPhase */1 :
        return ["CapturingPhase"];
    case /* AtTarget */2 :
        return ["AtTarget"];
    case /* BubblingPhase */3 :
        return ["BubblingPhase"];
    case /* Unknown */4 :
        return ["Unknown"];
    
  }
}

function eventPhase_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AtTarget" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AtTarget */2
                  };
          }
      case "BubblingPhase" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BubblingPhase */3
                  };
          }
      case "CapturingPhase" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CapturingPhase */1
                  };
          }
      case "None" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* None */0
                  };
          }
      case "Unknown" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Unknown */4
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function webapiEventPhaseToEventPhase(webapiEventPhase) {
  return webapiEventPhase;
}

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "bubbles",
                Decco.boolToJson(v.bubbles)
              ],
              [
                "cancelable",
                Decco.boolToJson(v.cancelable)
              ],
              [
                "composed",
                Decco.boolToJson(v.composed)
              ],
              [
                "currentTarget",
                Decco.optionToJson(t_encode, v.currentTarget)
              ],
              [
                "defaultPrevented",
                Decco.boolToJson(v.defaultPrevented)
              ],
              [
                "eventPhase",
                eventPhase_encode(v.eventPhase)
              ],
              [
                "target",
                t_encode(v.target)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ],
              [
                "type_",
                Decco.stringToJson(v.type_)
              ],
              [
                "isTrusted",
                Decco.boolToJson(v.isTrusted)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
  if (bubbles.TAG === /* Ok */0) {
    var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
    if (cancelable.TAG === /* Ok */0) {
      var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
      if (composed.TAG === /* Ok */0) {
        var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
        if (currentTarget.TAG === /* Ok */0) {
          var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
          if (defaultPrevented.TAG === /* Ok */0) {
            var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
            if (eventPhase.TAG === /* Ok */0) {
              var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
              if (target.TAG === /* Ok */0) {
                var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                if (timeStamp.TAG === /* Ok */0) {
                  var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                  if (type_.TAG === /* Ok */0) {
                    var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                    if (isTrusted.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: {
                                bubbles: bubbles._0,
                                cancelable: cancelable._0,
                                composed: composed._0,
                                currentTarget: currentTarget._0,
                                defaultPrevented: defaultPrevented._0,
                                eventPhase: eventPhase._0,
                                target: target._0,
                                timeStamp: timeStamp._0,
                                type_: type_._0,
                                isTrusted: isTrusted._0
                              }
                            };
                    }
                    var e = isTrusted._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".isTrusted" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = type_._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".type_" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }
                var e$2 = timeStamp._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".timeStamp" + e$2.path,
                          message: e$2.message,
                          value: e$2.value
                        }
                      };
              }
              var e$3 = target._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".target" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                      }
                    };
            }
            var e$4 = eventPhase._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".eventPhase" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = defaultPrevented._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".defaultPrevented" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
        }
        var e$6 = currentTarget._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".currentTarget" + e$6.path,
                  message: e$6.message,
                  value: e$6.value
                }
              };
      }
      var e$7 = composed._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".composed" + e$7.path,
                message: e$7.message,
                value: e$7.value
              }
            };
    }
    var e$8 = cancelable._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".cancelable" + e$8.path,
              message: e$8.message,
              value: e$8.value
            }
          };
  }
  var e$9 = bubbles._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".bubbles" + e$9.path,
            message: e$9.message,
            value: e$9.value
          }
        };
}

function fromDomEvent($$event) {
  return {
          bubbles: $$event.bubbles,
          cancelable: $$event.cancelable,
          composed: $$event.composed,
          currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
          defaultPrevented: $$event.defaultPrevented,
          eventPhase: Webapi__Dom__Event.eventPhase($$event),
          target: fromDomEventTarget($$event.target),
          timeStamp: $$event.timeStamp,
          type_: $$event.type,
          isTrusted: $$event.isTrusted
        };
}

function stringify$1($$event) {
  return JSON.stringify(t_encode$1($$event));
}

var EventForSerialization = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fromDomEvent: fromDomEvent,
  stringify: stringify$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "target",
                t_encode(v.target)
              ],
              [
                "clipboardWhenOpened",
                Decco.stringToJson(v.clipboardWhenOpened)
              ],
              [
                "clipboardWhenClosed",
                Decco.stringToJson(v.clipboardWhenClosed)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
  if (target.TAG === /* Ok */0) {
    var clipboardWhenOpened = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clipboardWhenOpened"), null));
    if (clipboardWhenOpened.TAG === /* Ok */0) {
      var clipboardWhenClosed = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clipboardWhenClosed"), null));
      if (clipboardWhenClosed.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  target: target._0,
                  clipboardWhenOpened: clipboardWhenOpened._0,
                  clipboardWhenClosed: clipboardWhenClosed._0
                }
              };
      }
      var e = clipboardWhenClosed._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".clipboardWhenClosed" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = clipboardWhenOpened._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".clipboardWhenOpened" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = target._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".target" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$2(param) {
  return "{target, clipboardWhenOpened: " + (StringUtils$SmartcutsMacros.quote(param.clipboardWhenOpened) + (", clipboardWhenClosed: " + (StringUtils$SmartcutsMacros.quote(param.clipboardWhenClosed) + "}")));
}

var ContextMenuClosedForSerialization = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$2
};

function t_encode$3(v) {
  return [
          "ContextMenuClosed",
          t_encode$2(v._0)
        ];
}

function t_decode$3(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ContextMenuClosed") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = t_decode$2(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ContextMenuClosed */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function fromSyntheticEvent($$event) {
  var match = $$event._0;
  return /* ContextMenuClosed */{
          _0: {
            target: fromDomEventTarget(match.target),
            clipboardWhenOpened: match.clipboardWhenOpened,
            clipboardWhenClosed: match.clipboardWhenClosed
          }
        };
}

function stringify$3($$event) {
  return "ContextMenuClosed(" + (stringify$2($$event._0) + ")");
}

var SyntheticEventForSerialization = {
  ContextMenuClosedForSerialization: ContextMenuClosedForSerialization,
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  fromSyntheticEvent: fromSyntheticEvent,
  stringify: stringify$3
};

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "altKey",
                Decco.boolToJson(v.altKey)
              ],
              [
                "button",
                Decco.intToJson(v.button)
              ],
              [
                "buttons",
                Decco.intToJson(v.buttons)
              ],
              [
                "clientX",
                Decco.floatToJson(v.clientX)
              ],
              [
                "clientY",
                Decco.floatToJson(v.clientY)
              ],
              [
                "ctrlKey",
                Decco.boolToJson(v.ctrlKey)
              ],
              [
                "metaKey",
                Decco.boolToJson(v.metaKey)
              ],
              [
                "movementX",
                Decco.intToJson(v.movementX)
              ],
              [
                "movementY",
                Decco.intToJson(v.movementY)
              ],
              [
                "offsetX",
                Decco.intToJson(v.offsetX)
              ],
              [
                "offsetY",
                Decco.intToJson(v.offsetY)
              ],
              [
                "pageX",
                Decco.intToJson(v.pageX)
              ],
              [
                "pageY",
                Decco.intToJson(v.pageY)
              ],
              [
                "region",
                Decco.optionToJson(Decco.stringToJson, v.region)
              ],
              [
                "relatedTarget",
                Decco.optionToJson(t_encode, v.relatedTarget)
              ],
              [
                "screenX",
                Decco.intToJson(v.screenX)
              ],
              [
                "screenY",
                Decco.intToJson(v.screenY)
              ],
              [
                "shiftKey",
                Decco.boolToJson(v.shiftKey)
              ],
              [
                "x",
                Decco.intToJson(v.x)
              ],
              [
                "y",
                Decco.intToJson(v.y)
              ],
              [
                "detail",
                Decco.intToJson(v.detail)
              ],
              [
                "bubbles",
                Decco.boolToJson(v.bubbles)
              ],
              [
                "cancelable",
                Decco.boolToJson(v.cancelable)
              ],
              [
                "composed",
                Decco.boolToJson(v.composed)
              ],
              [
                "currentTarget",
                Decco.optionToJson(t_encode, v.currentTarget)
              ],
              [
                "defaultPrevented",
                Decco.boolToJson(v.defaultPrevented)
              ],
              [
                "eventPhase",
                eventPhase_encode(v.eventPhase)
              ],
              [
                "target",
                t_encode(v.target)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ],
              [
                "type_",
                Decco.stringToJson(v.type_)
              ],
              [
                "isTrusted",
                Decco.boolToJson(v.isTrusted)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var altKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "altKey"), null));
  if (altKey.TAG === /* Ok */0) {
    var button = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "button"), null));
    if (button.TAG === /* Ok */0) {
      var buttons = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "buttons"), null));
      if (buttons.TAG === /* Ok */0) {
        var clientX = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientX"), null));
        if (clientX.TAG === /* Ok */0) {
          var clientY = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientY"), null));
          if (clientY.TAG === /* Ok */0) {
            var ctrlKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ctrlKey"), null));
            if (ctrlKey.TAG === /* Ok */0) {
              var metaKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metaKey"), null));
              if (metaKey.TAG === /* Ok */0) {
                var movementX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "movementX"), null));
                if (movementX.TAG === /* Ok */0) {
                  var movementY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "movementY"), null));
                  if (movementY.TAG === /* Ok */0) {
                    var offsetX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offsetX"), null));
                    if (offsetX.TAG === /* Ok */0) {
                      var offsetY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offsetY"), null));
                      if (offsetY.TAG === /* Ok */0) {
                        var pageX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageX"), null));
                        if (pageX.TAG === /* Ok */0) {
                          var pageY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageY"), null));
                          if (pageY.TAG === /* Ok */0) {
                            var region = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "region"), null));
                            if (region.TAG === /* Ok */0) {
                              var relatedTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "relatedTarget"), null));
                              if (relatedTarget.TAG === /* Ok */0) {
                                var screenX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenX"), null));
                                if (screenX.TAG === /* Ok */0) {
                                  var screenY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenY"), null));
                                  if (screenY.TAG === /* Ok */0) {
                                    var shiftKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "shiftKey"), null));
                                    if (shiftKey.TAG === /* Ok */0) {
                                      var x = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "x"), null));
                                      if (x.TAG === /* Ok */0) {
                                        var y = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "y"), null));
                                        if (y.TAG === /* Ok */0) {
                                          var detail = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
                                          if (detail.TAG === /* Ok */0) {
                                            var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
                                            if (bubbles.TAG === /* Ok */0) {
                                              var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
                                              if (cancelable.TAG === /* Ok */0) {
                                                var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
                                                if (composed.TAG === /* Ok */0) {
                                                  var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
                                                  if (currentTarget.TAG === /* Ok */0) {
                                                    var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                                                    if (defaultPrevented.TAG === /* Ok */0) {
                                                      var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                                                      if (eventPhase.TAG === /* Ok */0) {
                                                        var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                                                        if (target.TAG === /* Ok */0) {
                                                          var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                                          if (timeStamp.TAG === /* Ok */0) {
                                                            var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                                                            if (type_.TAG === /* Ok */0) {
                                                              var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                                                              if (isTrusted.TAG === /* Ok */0) {
                                                                return {
                                                                        TAG: /* Ok */0,
                                                                        _0: {
                                                                          altKey: altKey._0,
                                                                          button: button._0,
                                                                          buttons: buttons._0,
                                                                          clientX: clientX._0,
                                                                          clientY: clientY._0,
                                                                          ctrlKey: ctrlKey._0,
                                                                          metaKey: metaKey._0,
                                                                          movementX: movementX._0,
                                                                          movementY: movementY._0,
                                                                          offsetX: offsetX._0,
                                                                          offsetY: offsetY._0,
                                                                          pageX: pageX._0,
                                                                          pageY: pageY._0,
                                                                          region: region._0,
                                                                          relatedTarget: relatedTarget._0,
                                                                          screenX: screenX._0,
                                                                          screenY: screenY._0,
                                                                          shiftKey: shiftKey._0,
                                                                          x: x._0,
                                                                          y: y._0,
                                                                          detail: detail._0,
                                                                          bubbles: bubbles._0,
                                                                          cancelable: cancelable._0,
                                                                          composed: composed._0,
                                                                          currentTarget: currentTarget._0,
                                                                          defaultPrevented: defaultPrevented._0,
                                                                          eventPhase: eventPhase._0,
                                                                          target: target._0,
                                                                          timeStamp: timeStamp._0,
                                                                          type_: type_._0,
                                                                          isTrusted: isTrusted._0
                                                                        }
                                                                      };
                                                              }
                                                              var e = isTrusted._0;
                                                              return {
                                                                      TAG: /* Error */1,
                                                                      _0: {
                                                                        path: ".isTrusted" + e.path,
                                                                        message: e.message,
                                                                        value: e.value
                                                                      }
                                                                    };
                                                            }
                                                            var e$1 = type_._0;
                                                            return {
                                                                    TAG: /* Error */1,
                                                                    _0: {
                                                                      path: ".type_" + e$1.path,
                                                                      message: e$1.message,
                                                                      value: e$1.value
                                                                    }
                                                                  };
                                                          }
                                                          var e$2 = timeStamp._0;
                                                          return {
                                                                  TAG: /* Error */1,
                                                                  _0: {
                                                                    path: ".timeStamp" + e$2.path,
                                                                    message: e$2.message,
                                                                    value: e$2.value
                                                                  }
                                                                };
                                                        }
                                                        var e$3 = target._0;
                                                        return {
                                                                TAG: /* Error */1,
                                                                _0: {
                                                                  path: ".target" + e$3.path,
                                                                  message: e$3.message,
                                                                  value: e$3.value
                                                                }
                                                              };
                                                      }
                                                      var e$4 = eventPhase._0;
                                                      return {
                                                              TAG: /* Error */1,
                                                              _0: {
                                                                path: ".eventPhase" + e$4.path,
                                                                message: e$4.message,
                                                                value: e$4.value
                                                              }
                                                            };
                                                    }
                                                    var e$5 = defaultPrevented._0;
                                                    return {
                                                            TAG: /* Error */1,
                                                            _0: {
                                                              path: ".defaultPrevented" + e$5.path,
                                                              message: e$5.message,
                                                              value: e$5.value
                                                            }
                                                          };
                                                  }
                                                  var e$6 = currentTarget._0;
                                                  return {
                                                          TAG: /* Error */1,
                                                          _0: {
                                                            path: ".currentTarget" + e$6.path,
                                                            message: e$6.message,
                                                            value: e$6.value
                                                          }
                                                        };
                                                }
                                                var e$7 = composed._0;
                                                return {
                                                        TAG: /* Error */1,
                                                        _0: {
                                                          path: ".composed" + e$7.path,
                                                          message: e$7.message,
                                                          value: e$7.value
                                                        }
                                                      };
                                              }
                                              var e$8 = cancelable._0;
                                              return {
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        path: ".cancelable" + e$8.path,
                                                        message: e$8.message,
                                                        value: e$8.value
                                                      }
                                                    };
                                            }
                                            var e$9 = bubbles._0;
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      path: ".bubbles" + e$9.path,
                                                      message: e$9.message,
                                                      value: e$9.value
                                                    }
                                                  };
                                          }
                                          var e$10 = detail._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".detail" + e$10.path,
                                                    message: e$10.message,
                                                    value: e$10.value
                                                  }
                                                };
                                        }
                                        var e$11 = y._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".y" + e$11.path,
                                                  message: e$11.message,
                                                  value: e$11.value
                                                }
                                              };
                                      }
                                      var e$12 = x._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".x" + e$12.path,
                                                message: e$12.message,
                                                value: e$12.value
                                              }
                                            };
                                    }
                                    var e$13 = shiftKey._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".shiftKey" + e$13.path,
                                              message: e$13.message,
                                              value: e$13.value
                                            }
                                          };
                                  }
                                  var e$14 = screenY._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".screenY" + e$14.path,
                                            message: e$14.message,
                                            value: e$14.value
                                          }
                                        };
                                }
                                var e$15 = screenX._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".screenX" + e$15.path,
                                          message: e$15.message,
                                          value: e$15.value
                                        }
                                      };
                              }
                              var e$16 = relatedTarget._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".relatedTarget" + e$16.path,
                                        message: e$16.message,
                                        value: e$16.value
                                      }
                                    };
                            }
                            var e$17 = region._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".region" + e$17.path,
                                      message: e$17.message,
                                      value: e$17.value
                                    }
                                  };
                          }
                          var e$18 = pageY._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".pageY" + e$18.path,
                                    message: e$18.message,
                                    value: e$18.value
                                  }
                                };
                        }
                        var e$19 = pageX._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".pageX" + e$19.path,
                                  message: e$19.message,
                                  value: e$19.value
                                }
                              };
                      }
                      var e$20 = offsetY._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".offsetY" + e$20.path,
                                message: e$20.message,
                                value: e$20.value
                              }
                            };
                    }
                    var e$21 = offsetX._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".offsetX" + e$21.path,
                              message: e$21.message,
                              value: e$21.value
                            }
                          };
                  }
                  var e$22 = movementY._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".movementY" + e$22.path,
                            message: e$22.message,
                            value: e$22.value
                          }
                        };
                }
                var e$23 = movementX._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".movementX" + e$23.path,
                          message: e$23.message,
                          value: e$23.value
                        }
                      };
              }
              var e$24 = metaKey._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".metaKey" + e$24.path,
                        message: e$24.message,
                        value: e$24.value
                      }
                    };
            }
            var e$25 = ctrlKey._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".ctrlKey" + e$25.path,
                      message: e$25.message,
                      value: e$25.value
                    }
                  };
          }
          var e$26 = clientY._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".clientY" + e$26.path,
                    message: e$26.message,
                    value: e$26.value
                  }
                };
        }
        var e$27 = clientX._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".clientX" + e$27.path,
                  message: e$27.message,
                  value: e$27.value
                }
              };
      }
      var e$28 = buttons._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".buttons" + e$28.path,
                message: e$28.message,
                value: e$28.value
              }
            };
    }
    var e$29 = button._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".button" + e$29.path,
              message: e$29.message,
              value: e$29.value
            }
          };
  }
  var e$30 = altKey._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".altKey" + e$30.path,
            message: e$30.message,
            value: e$30.value
          }
        };
}

function fromDomMouseEvent($$event) {
  return {
          altKey: $$event.altKey,
          button: $$event.button,
          buttons: $$event.buttons,
          clientX: $$event.clientX,
          clientY: $$event.clientY,
          ctrlKey: $$event.ctrlKey,
          metaKey: $$event.metaKey,
          movementX: $$event.movementX,
          movementY: $$event.movementY,
          offsetX: $$event.offsetX,
          offsetY: $$event.offsetY,
          pageX: $$event.pageX,
          pageY: $$event.pageY,
          region: Caml_option.nullable_to_opt($$event.region),
          relatedTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.relatedTarget), fromDomEventTarget),
          screenX: $$event.screenX,
          screenY: $$event.screenY,
          shiftKey: $$event.shiftKey,
          x: $$event.x,
          y: $$event.y,
          detail: $$event.detail,
          bubbles: $$event.bubbles,
          cancelable: $$event.cancelable,
          composed: $$event.composed,
          currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
          defaultPrevented: $$event.defaultPrevented,
          eventPhase: Curry._1(Webapi__Dom__MouseEvent.eventPhase, $$event),
          target: fromDomEventTarget($$event.target),
          timeStamp: $$event.timeStamp,
          type_: $$event.type,
          isTrusted: $$event.isTrusted
        };
}

function stringify$4($$event) {
  return JSON.stringify(t_encode$4($$event));
}

var MouseEventForSerialization = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  fromDomMouseEvent: fromDomMouseEvent,
  stringify: stringify$4
};

function t_encode$5(v) {
  return Js_dict.fromArray([
              [
                "data",
                Decco.optionToJson(Decco.stringToJson, v.data)
              ],
              [
                "isComposing",
                Decco.boolToJson(v.isComposing)
              ],
              [
                "detail",
                Decco.intToJson(v.detail)
              ],
              [
                "bubbles",
                Decco.boolToJson(v.bubbles)
              ],
              [
                "cancelable",
                Decco.boolToJson(v.cancelable)
              ],
              [
                "composed",
                Decco.boolToJson(v.composed)
              ],
              [
                "currentTarget",
                Decco.optionToJson(t_encode, v.currentTarget)
              ],
              [
                "defaultPrevented",
                Decco.boolToJson(v.defaultPrevented)
              ],
              [
                "eventPhase",
                eventPhase_encode(v.eventPhase)
              ],
              [
                "target",
                t_encode(v.target)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ],
              [
                "type_",
                Decco.stringToJson(v.type_)
              ],
              [
                "isTrusted",
                Decco.boolToJson(v.isTrusted)
              ]
            ]);
}

function t_decode$5(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var data = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "data"), null));
  if (data.TAG === /* Ok */0) {
    var isComposing = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isComposing"), null));
    if (isComposing.TAG === /* Ok */0) {
      var detail = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
      if (detail.TAG === /* Ok */0) {
        var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
        if (bubbles.TAG === /* Ok */0) {
          var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
          if (cancelable.TAG === /* Ok */0) {
            var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
            if (composed.TAG === /* Ok */0) {
              var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
              if (currentTarget.TAG === /* Ok */0) {
                var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                if (defaultPrevented.TAG === /* Ok */0) {
                  var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                  if (eventPhase.TAG === /* Ok */0) {
                    var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                    if (target.TAG === /* Ok */0) {
                      var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                      if (timeStamp.TAG === /* Ok */0) {
                        var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                        if (type_.TAG === /* Ok */0) {
                          var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                          if (isTrusted.TAG === /* Ok */0) {
                            return {
                                    TAG: /* Ok */0,
                                    _0: {
                                      data: data._0,
                                      isComposing: isComposing._0,
                                      detail: detail._0,
                                      bubbles: bubbles._0,
                                      cancelable: cancelable._0,
                                      composed: composed._0,
                                      currentTarget: currentTarget._0,
                                      defaultPrevented: defaultPrevented._0,
                                      eventPhase: eventPhase._0,
                                      target: target._0,
                                      timeStamp: timeStamp._0,
                                      type_: type_._0,
                                      isTrusted: isTrusted._0
                                    }
                                  };
                          }
                          var e = isTrusted._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".isTrusted" + e.path,
                                    message: e.message,
                                    value: e.value
                                  }
                                };
                        }
                        var e$1 = type_._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".type_" + e$1.path,
                                  message: e$1.message,
                                  value: e$1.value
                                }
                              };
                      }
                      var e$2 = timeStamp._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".timeStamp" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                              }
                            };
                    }
                    var e$3 = target._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".target" + e$3.path,
                              message: e$3.message,
                              value: e$3.value
                            }
                          };
                  }
                  var e$4 = eventPhase._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".eventPhase" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                          }
                        };
                }
                var e$5 = defaultPrevented._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".defaultPrevented" + e$5.path,
                          message: e$5.message,
                          value: e$5.value
                        }
                      };
              }
              var e$6 = currentTarget._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".currentTarget" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                      }
                    };
            }
            var e$7 = composed._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".composed" + e$7.path,
                      message: e$7.message,
                      value: e$7.value
                    }
                  };
          }
          var e$8 = cancelable._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".cancelable" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
        }
        var e$9 = bubbles._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".bubbles" + e$9.path,
                  message: e$9.message,
                  value: e$9.value
                }
              };
      }
      var e$10 = detail._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".detail" + e$10.path,
                message: e$10.message,
                value: e$10.value
              }
            };
    }
    var e$11 = isComposing._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".isComposing" + e$11.path,
              message: e$11.message,
              value: e$11.value
            }
          };
  }
  var e$12 = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e$12.path,
            message: e$12.message,
            value: e$12.value
          }
        };
}

function fromDomInputEvent($$event) {
  return {
          data: Belt_Option.flatMap(Caml_option.nullable_to_opt($$event.data), (function (str) {
                  if (str == null) {
                    return ;
                  } else {
                    return Caml_option.some(str);
                  }
                })),
          isComposing: $$event.isComposing,
          detail: $$event.detail,
          bubbles: $$event.bubbles,
          cancelable: $$event.cancelable,
          composed: $$event.composed,
          currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
          defaultPrevented: $$event.defaultPrevented,
          eventPhase: Curry._1(Webapi__Dom__InputEvent.eventPhase, $$event),
          target: fromDomEventTarget($$event.target),
          timeStamp: $$event.timeStamp,
          type_: $$event.type,
          isTrusted: $$event.isTrusted
        };
}

function stringify$5($$event) {
  return JSON.stringify(t_encode$5($$event));
}

var InputEventForSerialization = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  fromDomInputEvent: fromDomInputEvent,
  stringify: stringify$5
};

function t_encode$6(v) {
  return Js_dict.fromArray([
              [
                "altKey",
                Decco.boolToJson(v.altKey)
              ],
              [
                "code",
                Decco.stringToJson(v.code)
              ],
              [
                "ctrlKey",
                Decco.boolToJson(v.ctrlKey)
              ],
              [
                "isComposing",
                Decco.boolToJson(v.isComposing)
              ],
              [
                "key",
                Decco.stringToJson(v.key)
              ],
              [
                "location",
                Decco.intToJson(v.location)
              ],
              [
                "metaKey",
                Decco.boolToJson(v.metaKey)
              ],
              [
                "repeat",
                Decco.boolToJson(v.repeat)
              ],
              [
                "shiftKey",
                Decco.boolToJson(v.shiftKey)
              ],
              [
                "detail",
                Decco.intToJson(v.detail)
              ],
              [
                "bubbles",
                Decco.boolToJson(v.bubbles)
              ],
              [
                "cancelable",
                Decco.boolToJson(v.cancelable)
              ],
              [
                "composed",
                Decco.boolToJson(v.composed)
              ],
              [
                "currentTarget",
                Decco.optionToJson(t_encode, v.currentTarget)
              ],
              [
                "defaultPrevented",
                Decco.boolToJson(v.defaultPrevented)
              ],
              [
                "eventPhase",
                eventPhase_encode(v.eventPhase)
              ],
              [
                "target",
                t_encode(v.target)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ],
              [
                "type_",
                Decco.stringToJson(v.type_)
              ],
              [
                "isTrusted",
                Decco.boolToJson(v.isTrusted)
              ]
            ]);
}

function t_decode$6(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var altKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "altKey"), null));
  if (altKey.TAG === /* Ok */0) {
    var code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
    if (code.TAG === /* Ok */0) {
      var ctrlKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ctrlKey"), null));
      if (ctrlKey.TAG === /* Ok */0) {
        var isComposing = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isComposing"), null));
        if (isComposing.TAG === /* Ok */0) {
          var key = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "key"), null));
          if (key.TAG === /* Ok */0) {
            var $$location = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "location"), null));
            if ($$location.TAG === /* Ok */0) {
              var metaKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metaKey"), null));
              if (metaKey.TAG === /* Ok */0) {
                var repeat = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "repeat"), null));
                if (repeat.TAG === /* Ok */0) {
                  var shiftKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "shiftKey"), null));
                  if (shiftKey.TAG === /* Ok */0) {
                    var detail = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
                    if (detail.TAG === /* Ok */0) {
                      var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
                      if (bubbles.TAG === /* Ok */0) {
                        var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
                        if (cancelable.TAG === /* Ok */0) {
                          var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
                          if (composed.TAG === /* Ok */0) {
                            var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
                            if (currentTarget.TAG === /* Ok */0) {
                              var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                              if (defaultPrevented.TAG === /* Ok */0) {
                                var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                                if (eventPhase.TAG === /* Ok */0) {
                                  var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                                  if (target.TAG === /* Ok */0) {
                                    var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                    if (timeStamp.TAG === /* Ok */0) {
                                      var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                                      if (type_.TAG === /* Ok */0) {
                                        var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                                        if (isTrusted.TAG === /* Ok */0) {
                                          return {
                                                  TAG: /* Ok */0,
                                                  _0: {
                                                    altKey: altKey._0,
                                                    code: code._0,
                                                    ctrlKey: ctrlKey._0,
                                                    isComposing: isComposing._0,
                                                    key: key._0,
                                                    location: $$location._0,
                                                    metaKey: metaKey._0,
                                                    repeat: repeat._0,
                                                    shiftKey: shiftKey._0,
                                                    detail: detail._0,
                                                    bubbles: bubbles._0,
                                                    cancelable: cancelable._0,
                                                    composed: composed._0,
                                                    currentTarget: currentTarget._0,
                                                    defaultPrevented: defaultPrevented._0,
                                                    eventPhase: eventPhase._0,
                                                    target: target._0,
                                                    timeStamp: timeStamp._0,
                                                    type_: type_._0,
                                                    isTrusted: isTrusted._0
                                                  }
                                                };
                                        }
                                        var e = isTrusted._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".isTrusted" + e.path,
                                                  message: e.message,
                                                  value: e.value
                                                }
                                              };
                                      }
                                      var e$1 = type_._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".type_" + e$1.path,
                                                message: e$1.message,
                                                value: e$1.value
                                              }
                                            };
                                    }
                                    var e$2 = timeStamp._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".timeStamp" + e$2.path,
                                              message: e$2.message,
                                              value: e$2.value
                                            }
                                          };
                                  }
                                  var e$3 = target._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".target" + e$3.path,
                                            message: e$3.message,
                                            value: e$3.value
                                          }
                                        };
                                }
                                var e$4 = eventPhase._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".eventPhase" + e$4.path,
                                          message: e$4.message,
                                          value: e$4.value
                                        }
                                      };
                              }
                              var e$5 = defaultPrevented._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".defaultPrevented" + e$5.path,
                                        message: e$5.message,
                                        value: e$5.value
                                      }
                                    };
                            }
                            var e$6 = currentTarget._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".currentTarget" + e$6.path,
                                      message: e$6.message,
                                      value: e$6.value
                                    }
                                  };
                          }
                          var e$7 = composed._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".composed" + e$7.path,
                                    message: e$7.message,
                                    value: e$7.value
                                  }
                                };
                        }
                        var e$8 = cancelable._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".cancelable" + e$8.path,
                                  message: e$8.message,
                                  value: e$8.value
                                }
                              };
                      }
                      var e$9 = bubbles._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".bubbles" + e$9.path,
                                message: e$9.message,
                                value: e$9.value
                              }
                            };
                    }
                    var e$10 = detail._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".detail" + e$10.path,
                              message: e$10.message,
                              value: e$10.value
                            }
                          };
                  }
                  var e$11 = shiftKey._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".shiftKey" + e$11.path,
                            message: e$11.message,
                            value: e$11.value
                          }
                        };
                }
                var e$12 = repeat._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".repeat" + e$12.path,
                          message: e$12.message,
                          value: e$12.value
                        }
                      };
              }
              var e$13 = metaKey._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".metaKey" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                      }
                    };
            }
            var e$14 = $$location._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".location" + e$14.path,
                      message: e$14.message,
                      value: e$14.value
                    }
                  };
          }
          var e$15 = key._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".key" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
        }
        var e$16 = isComposing._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".isComposing" + e$16.path,
                  message: e$16.message,
                  value: e$16.value
                }
              };
      }
      var e$17 = ctrlKey._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".ctrlKey" + e$17.path,
                message: e$17.message,
                value: e$17.value
              }
            };
    }
    var e$18 = code._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".code" + e$18.path,
              message: e$18.message,
              value: e$18.value
            }
          };
  }
  var e$19 = altKey._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".altKey" + e$19.path,
            message: e$19.message,
            value: e$19.value
          }
        };
}

function fromDomKeyboardEvent($$event) {
  return {
          altKey: $$event.altKey,
          code: $$event.code,
          ctrlKey: $$event.ctrlKey,
          isComposing: $$event.isComposing,
          key: $$event.key,
          location: $$event.location,
          metaKey: $$event.metaKey,
          repeat: $$event.repeat,
          shiftKey: $$event.shiftKey,
          detail: $$event.detail,
          bubbles: $$event.bubbles,
          cancelable: $$event.cancelable,
          composed: $$event.composed,
          currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
          defaultPrevented: $$event.defaultPrevented,
          eventPhase: Curry._1(Webapi__Dom__KeyboardEvent.eventPhase, $$event),
          target: fromDomEventTarget($$event.target),
          timeStamp: $$event.timeStamp,
          type_: $$event.type,
          isTrusted: $$event.isTrusted
        };
}

function stringify$6($$event) {
  return JSON.stringify(t_encode$6($$event));
}

var KeyboardEventForSerialization = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  fromDomKeyboardEvent: fromDomKeyboardEvent,
  stringify: stringify$6
};

function t_encode$7(v) {
  return Js_dict.fromArray([
              [
                "clipboardData",
                Decco.stringToJson(v.clipboardData)
              ],
              [
                "bubbles",
                Decco.boolToJson(v.bubbles)
              ],
              [
                "cancelable",
                Decco.boolToJson(v.cancelable)
              ],
              [
                "composed",
                Decco.boolToJson(v.composed)
              ],
              [
                "currentTarget",
                Decco.optionToJson(t_encode, v.currentTarget)
              ],
              [
                "defaultPrevented",
                Decco.boolToJson(v.defaultPrevented)
              ],
              [
                "eventPhase",
                eventPhase_encode(v.eventPhase)
              ],
              [
                "target",
                t_encode(v.target)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ],
              [
                "type_",
                Decco.stringToJson(v.type_)
              ],
              [
                "isTrusted",
                Decco.boolToJson(v.isTrusted)
              ]
            ]);
}

function t_decode$7(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var clipboardData = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clipboardData"), null));
  if (clipboardData.TAG === /* Ok */0) {
    var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
    if (bubbles.TAG === /* Ok */0) {
      var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
      if (cancelable.TAG === /* Ok */0) {
        var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
        if (composed.TAG === /* Ok */0) {
          var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
          if (currentTarget.TAG === /* Ok */0) {
            var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
            if (defaultPrevented.TAG === /* Ok */0) {
              var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
              if (eventPhase.TAG === /* Ok */0) {
                var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                if (target.TAG === /* Ok */0) {
                  var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                  if (timeStamp.TAG === /* Ok */0) {
                    var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                    if (type_.TAG === /* Ok */0) {
                      var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                      if (isTrusted.TAG === /* Ok */0) {
                        return {
                                TAG: /* Ok */0,
                                _0: {
                                  clipboardData: clipboardData._0,
                                  bubbles: bubbles._0,
                                  cancelable: cancelable._0,
                                  composed: composed._0,
                                  currentTarget: currentTarget._0,
                                  defaultPrevented: defaultPrevented._0,
                                  eventPhase: eventPhase._0,
                                  target: target._0,
                                  timeStamp: timeStamp._0,
                                  type_: type_._0,
                                  isTrusted: isTrusted._0
                                }
                              };
                      }
                      var e = isTrusted._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".isTrusted" + e.path,
                                message: e.message,
                                value: e.value
                              }
                            };
                    }
                    var e$1 = type_._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".type_" + e$1.path,
                              message: e$1.message,
                              value: e$1.value
                            }
                          };
                  }
                  var e$2 = timeStamp._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".timeStamp" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                          }
                        };
                }
                var e$3 = target._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".target" + e$3.path,
                          message: e$3.message,
                          value: e$3.value
                        }
                      };
              }
              var e$4 = eventPhase._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".eventPhase" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = defaultPrevented._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".defaultPrevented" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = currentTarget._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".currentTarget" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
        }
        var e$7 = composed._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".composed" + e$7.path,
                  message: e$7.message,
                  value: e$7.value
                }
              };
      }
      var e$8 = cancelable._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".cancelable" + e$8.path,
                message: e$8.message,
                value: e$8.value
              }
            };
    }
    var e$9 = bubbles._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".bubbles" + e$9.path,
              message: e$9.message,
              value: e$9.value
            }
          };
  }
  var e$10 = clipboardData._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".clipboardData" + e$10.path,
            message: e$10.message,
            value: e$10.value
          }
        };
}

function fromDomClipboardEvent($$event) {
  return {
          clipboardData: DOM__DataTransfer$SmartcutsMacros.getData("text", $$event.clipboardData),
          bubbles: $$event.bubbles,
          cancelable: $$event.cancelable,
          composed: $$event.composed,
          currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
          defaultPrevented: $$event.defaultPrevented,
          eventPhase: Curry._1(Webapi__Dom__ClipboardEvent.eventPhase, $$event),
          target: fromDomEventTarget($$event.target),
          timeStamp: $$event.timeStamp,
          type_: $$event.type,
          isTrusted: $$event.isTrusted
        };
}

function stringify$7($$event) {
  return JSON.stringify(t_encode$7($$event));
}

var ClipboardEventForSerialization = {
  t_encode: t_encode$7,
  t_decode: t_decode$7,
  fromDomClipboardEvent: fromDomClipboardEvent,
  stringify: stringify$7
};

function t_encode$8(v) {
  return Js_dict.fromArray([
              [
                "dataTransfer",
                Decco.stringToJson(v.dataTransfer)
              ],
              [
                "altKey",
                Decco.boolToJson(v.altKey)
              ],
              [
                "button",
                Decco.intToJson(v.button)
              ],
              [
                "buttons",
                Decco.intToJson(v.buttons)
              ],
              [
                "clientX",
                Decco.floatToJson(v.clientX)
              ],
              [
                "clientY",
                Decco.floatToJson(v.clientY)
              ],
              [
                "ctrlKey",
                Decco.boolToJson(v.ctrlKey)
              ],
              [
                "metaKey",
                Decco.boolToJson(v.metaKey)
              ],
              [
                "movementX",
                Decco.intToJson(v.movementX)
              ],
              [
                "movementY",
                Decco.intToJson(v.movementY)
              ],
              [
                "offsetX",
                Decco.intToJson(v.offsetX)
              ],
              [
                "offsetY",
                Decco.intToJson(v.offsetY)
              ],
              [
                "pageX",
                Decco.intToJson(v.pageX)
              ],
              [
                "pageY",
                Decco.intToJson(v.pageY)
              ],
              [
                "region",
                Decco.optionToJson(Decco.stringToJson, v.region)
              ],
              [
                "relatedTarget",
                Decco.optionToJson(t_encode, v.relatedTarget)
              ],
              [
                "screenX",
                Decco.intToJson(v.screenX)
              ],
              [
                "screenY",
                Decco.intToJson(v.screenY)
              ],
              [
                "shiftKey",
                Decco.boolToJson(v.shiftKey)
              ],
              [
                "x",
                Decco.intToJson(v.x)
              ],
              [
                "y",
                Decco.intToJson(v.y)
              ],
              [
                "detail",
                Decco.intToJson(v.detail)
              ],
              [
                "bubbles",
                Decco.boolToJson(v.bubbles)
              ],
              [
                "cancelable",
                Decco.boolToJson(v.cancelable)
              ],
              [
                "composed",
                Decco.boolToJson(v.composed)
              ],
              [
                "currentTarget",
                Decco.optionToJson(t_encode, v.currentTarget)
              ],
              [
                "defaultPrevented",
                Decco.boolToJson(v.defaultPrevented)
              ],
              [
                "eventPhase",
                eventPhase_encode(v.eventPhase)
              ],
              [
                "target",
                t_encode(v.target)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ],
              [
                "type_",
                Decco.stringToJson(v.type_)
              ],
              [
                "isTrusted",
                Decco.boolToJson(v.isTrusted)
              ]
            ]);
}

function t_decode$8(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var dataTransfer = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataTransfer"), null));
  if (dataTransfer.TAG === /* Ok */0) {
    var altKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "altKey"), null));
    if (altKey.TAG === /* Ok */0) {
      var button = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "button"), null));
      if (button.TAG === /* Ok */0) {
        var buttons = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "buttons"), null));
        if (buttons.TAG === /* Ok */0) {
          var clientX = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientX"), null));
          if (clientX.TAG === /* Ok */0) {
            var clientY = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientY"), null));
            if (clientY.TAG === /* Ok */0) {
              var ctrlKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ctrlKey"), null));
              if (ctrlKey.TAG === /* Ok */0) {
                var metaKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metaKey"), null));
                if (metaKey.TAG === /* Ok */0) {
                  var movementX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "movementX"), null));
                  if (movementX.TAG === /* Ok */0) {
                    var movementY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "movementY"), null));
                    if (movementY.TAG === /* Ok */0) {
                      var offsetX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offsetX"), null));
                      if (offsetX.TAG === /* Ok */0) {
                        var offsetY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offsetY"), null));
                        if (offsetY.TAG === /* Ok */0) {
                          var pageX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageX"), null));
                          if (pageX.TAG === /* Ok */0) {
                            var pageY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageY"), null));
                            if (pageY.TAG === /* Ok */0) {
                              var region = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "region"), null));
                              if (region.TAG === /* Ok */0) {
                                var relatedTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "relatedTarget"), null));
                                if (relatedTarget.TAG === /* Ok */0) {
                                  var screenX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenX"), null));
                                  if (screenX.TAG === /* Ok */0) {
                                    var screenY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenY"), null));
                                    if (screenY.TAG === /* Ok */0) {
                                      var shiftKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "shiftKey"), null));
                                      if (shiftKey.TAG === /* Ok */0) {
                                        var x = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "x"), null));
                                        if (x.TAG === /* Ok */0) {
                                          var y = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "y"), null));
                                          if (y.TAG === /* Ok */0) {
                                            var detail = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
                                            if (detail.TAG === /* Ok */0) {
                                              var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
                                              if (bubbles.TAG === /* Ok */0) {
                                                var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
                                                if (cancelable.TAG === /* Ok */0) {
                                                  var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
                                                  if (composed.TAG === /* Ok */0) {
                                                    var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
                                                    if (currentTarget.TAG === /* Ok */0) {
                                                      var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                                                      if (defaultPrevented.TAG === /* Ok */0) {
                                                        var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                                                        if (eventPhase.TAG === /* Ok */0) {
                                                          var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                                                          if (target.TAG === /* Ok */0) {
                                                            var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                                            if (timeStamp.TAG === /* Ok */0) {
                                                              var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                                                              if (type_.TAG === /* Ok */0) {
                                                                var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                                                                if (isTrusted.TAG === /* Ok */0) {
                                                                  return {
                                                                          TAG: /* Ok */0,
                                                                          _0: {
                                                                            dataTransfer: dataTransfer._0,
                                                                            altKey: altKey._0,
                                                                            button: button._0,
                                                                            buttons: buttons._0,
                                                                            clientX: clientX._0,
                                                                            clientY: clientY._0,
                                                                            ctrlKey: ctrlKey._0,
                                                                            metaKey: metaKey._0,
                                                                            movementX: movementX._0,
                                                                            movementY: movementY._0,
                                                                            offsetX: offsetX._0,
                                                                            offsetY: offsetY._0,
                                                                            pageX: pageX._0,
                                                                            pageY: pageY._0,
                                                                            region: region._0,
                                                                            relatedTarget: relatedTarget._0,
                                                                            screenX: screenX._0,
                                                                            screenY: screenY._0,
                                                                            shiftKey: shiftKey._0,
                                                                            x: x._0,
                                                                            y: y._0,
                                                                            detail: detail._0,
                                                                            bubbles: bubbles._0,
                                                                            cancelable: cancelable._0,
                                                                            composed: composed._0,
                                                                            currentTarget: currentTarget._0,
                                                                            defaultPrevented: defaultPrevented._0,
                                                                            eventPhase: eventPhase._0,
                                                                            target: target._0,
                                                                            timeStamp: timeStamp._0,
                                                                            type_: type_._0,
                                                                            isTrusted: isTrusted._0
                                                                          }
                                                                        };
                                                                }
                                                                var e = isTrusted._0;
                                                                return {
                                                                        TAG: /* Error */1,
                                                                        _0: {
                                                                          path: ".isTrusted" + e.path,
                                                                          message: e.message,
                                                                          value: e.value
                                                                        }
                                                                      };
                                                              }
                                                              var e$1 = type_._0;
                                                              return {
                                                                      TAG: /* Error */1,
                                                                      _0: {
                                                                        path: ".type_" + e$1.path,
                                                                        message: e$1.message,
                                                                        value: e$1.value
                                                                      }
                                                                    };
                                                            }
                                                            var e$2 = timeStamp._0;
                                                            return {
                                                                    TAG: /* Error */1,
                                                                    _0: {
                                                                      path: ".timeStamp" + e$2.path,
                                                                      message: e$2.message,
                                                                      value: e$2.value
                                                                    }
                                                                  };
                                                          }
                                                          var e$3 = target._0;
                                                          return {
                                                                  TAG: /* Error */1,
                                                                  _0: {
                                                                    path: ".target" + e$3.path,
                                                                    message: e$3.message,
                                                                    value: e$3.value
                                                                  }
                                                                };
                                                        }
                                                        var e$4 = eventPhase._0;
                                                        return {
                                                                TAG: /* Error */1,
                                                                _0: {
                                                                  path: ".eventPhase" + e$4.path,
                                                                  message: e$4.message,
                                                                  value: e$4.value
                                                                }
                                                              };
                                                      }
                                                      var e$5 = defaultPrevented._0;
                                                      return {
                                                              TAG: /* Error */1,
                                                              _0: {
                                                                path: ".defaultPrevented" + e$5.path,
                                                                message: e$5.message,
                                                                value: e$5.value
                                                              }
                                                            };
                                                    }
                                                    var e$6 = currentTarget._0;
                                                    return {
                                                            TAG: /* Error */1,
                                                            _0: {
                                                              path: ".currentTarget" + e$6.path,
                                                              message: e$6.message,
                                                              value: e$6.value
                                                            }
                                                          };
                                                  }
                                                  var e$7 = composed._0;
                                                  return {
                                                          TAG: /* Error */1,
                                                          _0: {
                                                            path: ".composed" + e$7.path,
                                                            message: e$7.message,
                                                            value: e$7.value
                                                          }
                                                        };
                                                }
                                                var e$8 = cancelable._0;
                                                return {
                                                        TAG: /* Error */1,
                                                        _0: {
                                                          path: ".cancelable" + e$8.path,
                                                          message: e$8.message,
                                                          value: e$8.value
                                                        }
                                                      };
                                              }
                                              var e$9 = bubbles._0;
                                              return {
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        path: ".bubbles" + e$9.path,
                                                        message: e$9.message,
                                                        value: e$9.value
                                                      }
                                                    };
                                            }
                                            var e$10 = detail._0;
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      path: ".detail" + e$10.path,
                                                      message: e$10.message,
                                                      value: e$10.value
                                                    }
                                                  };
                                          }
                                          var e$11 = y._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".y" + e$11.path,
                                                    message: e$11.message,
                                                    value: e$11.value
                                                  }
                                                };
                                        }
                                        var e$12 = x._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".x" + e$12.path,
                                                  message: e$12.message,
                                                  value: e$12.value
                                                }
                                              };
                                      }
                                      var e$13 = shiftKey._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".shiftKey" + e$13.path,
                                                message: e$13.message,
                                                value: e$13.value
                                              }
                                            };
                                    }
                                    var e$14 = screenY._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".screenY" + e$14.path,
                                              message: e$14.message,
                                              value: e$14.value
                                            }
                                          };
                                  }
                                  var e$15 = screenX._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".screenX" + e$15.path,
                                            message: e$15.message,
                                            value: e$15.value
                                          }
                                        };
                                }
                                var e$16 = relatedTarget._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".relatedTarget" + e$16.path,
                                          message: e$16.message,
                                          value: e$16.value
                                        }
                                      };
                              }
                              var e$17 = region._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".region" + e$17.path,
                                        message: e$17.message,
                                        value: e$17.value
                                      }
                                    };
                            }
                            var e$18 = pageY._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".pageY" + e$18.path,
                                      message: e$18.message,
                                      value: e$18.value
                                    }
                                  };
                          }
                          var e$19 = pageX._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".pageX" + e$19.path,
                                    message: e$19.message,
                                    value: e$19.value
                                  }
                                };
                        }
                        var e$20 = offsetY._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".offsetY" + e$20.path,
                                  message: e$20.message,
                                  value: e$20.value
                                }
                              };
                      }
                      var e$21 = offsetX._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".offsetX" + e$21.path,
                                message: e$21.message,
                                value: e$21.value
                              }
                            };
                    }
                    var e$22 = movementY._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".movementY" + e$22.path,
                              message: e$22.message,
                              value: e$22.value
                            }
                          };
                  }
                  var e$23 = movementX._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".movementX" + e$23.path,
                            message: e$23.message,
                            value: e$23.value
                          }
                        };
                }
                var e$24 = metaKey._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".metaKey" + e$24.path,
                          message: e$24.message,
                          value: e$24.value
                        }
                      };
              }
              var e$25 = ctrlKey._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".ctrlKey" + e$25.path,
                        message: e$25.message,
                        value: e$25.value
                      }
                    };
            }
            var e$26 = clientY._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".clientY" + e$26.path,
                      message: e$26.message,
                      value: e$26.value
                    }
                  };
          }
          var e$27 = clientX._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".clientX" + e$27.path,
                    message: e$27.message,
                    value: e$27.value
                  }
                };
        }
        var e$28 = buttons._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".buttons" + e$28.path,
                  message: e$28.message,
                  value: e$28.value
                }
              };
      }
      var e$29 = button._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".button" + e$29.path,
                message: e$29.message,
                value: e$29.value
              }
            };
    }
    var e$30 = altKey._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".altKey" + e$30.path,
              message: e$30.message,
              value: e$30.value
            }
          };
  }
  var e$31 = dataTransfer._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".dataTransfer" + e$31.path,
            message: e$31.message,
            value: e$31.value
          }
        };
}

function fromDomDragEvent($$event) {
  return {
          dataTransfer: DOM__DataTransfer$SmartcutsMacros.getData("text", $$event.dataTransfer),
          altKey: $$event.altKey,
          button: $$event.button,
          buttons: $$event.buttons,
          clientX: $$event.clientX,
          clientY: $$event.clientY,
          ctrlKey: $$event.ctrlKey,
          metaKey: $$event.metaKey,
          movementX: $$event.movementX,
          movementY: $$event.movementY,
          offsetX: $$event.offsetX,
          offsetY: $$event.offsetY,
          pageX: $$event.pageX,
          pageY: $$event.pageY,
          region: Caml_option.nullable_to_opt($$event.region),
          relatedTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.relatedTarget), fromDomEventTarget),
          screenX: $$event.screenX,
          screenY: $$event.screenY,
          shiftKey: $$event.shiftKey,
          x: $$event.x,
          y: $$event.y,
          detail: $$event.detail,
          bubbles: $$event.bubbles,
          cancelable: $$event.cancelable,
          composed: $$event.composed,
          currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
          defaultPrevented: $$event.defaultPrevented,
          eventPhase: Curry._1(Webapi__Dom__DragEvent.eventPhase, $$event),
          target: fromDomEventTarget($$event.target),
          timeStamp: $$event.timeStamp,
          type_: $$event.type,
          isTrusted: $$event.isTrusted
        };
}

function stringify$8($$event) {
  return JSON.stringify(t_encode$8($$event));
}

var DragEventForSerialization = {
  t_encode: t_encode$8,
  t_decode: t_decode$8,
  fromDomDragEvent: fromDomDragEvent,
  stringify: stringify$8
};

function t_encode$9(v) {
  return Js_dict.fromArray([
              [
                "relatedTarget",
                Decco.optionToJson(t_encode, v.relatedTarget)
              ],
              [
                "detail",
                Decco.intToJson(v.detail)
              ],
              [
                "bubbles",
                Decco.boolToJson(v.bubbles)
              ],
              [
                "cancelable",
                Decco.boolToJson(v.cancelable)
              ],
              [
                "composed",
                Decco.boolToJson(v.composed)
              ],
              [
                "currentTarget",
                Decco.optionToJson(t_encode, v.currentTarget)
              ],
              [
                "defaultPrevented",
                Decco.boolToJson(v.defaultPrevented)
              ],
              [
                "eventPhase",
                eventPhase_encode(v.eventPhase)
              ],
              [
                "target",
                t_encode(v.target)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ],
              [
                "type_",
                Decco.stringToJson(v.type_)
              ],
              [
                "isTrusted",
                Decco.boolToJson(v.isTrusted)
              ]
            ]);
}

function t_decode$9(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var relatedTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "relatedTarget"), null));
  if (relatedTarget.TAG === /* Ok */0) {
    var detail = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
    if (detail.TAG === /* Ok */0) {
      var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
      if (bubbles.TAG === /* Ok */0) {
        var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
        if (cancelable.TAG === /* Ok */0) {
          var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
          if (composed.TAG === /* Ok */0) {
            var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
            if (currentTarget.TAG === /* Ok */0) {
              var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
              if (defaultPrevented.TAG === /* Ok */0) {
                var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                if (eventPhase.TAG === /* Ok */0) {
                  var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                  if (target.TAG === /* Ok */0) {
                    var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                    if (timeStamp.TAG === /* Ok */0) {
                      var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                      if (type_.TAG === /* Ok */0) {
                        var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                        if (isTrusted.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Ok */0,
                                  _0: {
                                    relatedTarget: relatedTarget._0,
                                    detail: detail._0,
                                    bubbles: bubbles._0,
                                    cancelable: cancelable._0,
                                    composed: composed._0,
                                    currentTarget: currentTarget._0,
                                    defaultPrevented: defaultPrevented._0,
                                    eventPhase: eventPhase._0,
                                    target: target._0,
                                    timeStamp: timeStamp._0,
                                    type_: type_._0,
                                    isTrusted: isTrusted._0
                                  }
                                };
                        }
                        var e = isTrusted._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".isTrusted" + e.path,
                                  message: e.message,
                                  value: e.value
                                }
                              };
                      }
                      var e$1 = type_._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".type_" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                              }
                            };
                    }
                    var e$2 = timeStamp._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".timeStamp" + e$2.path,
                              message: e$2.message,
                              value: e$2.value
                            }
                          };
                  }
                  var e$3 = target._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".target" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                          }
                        };
                }
                var e$4 = eventPhase._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".eventPhase" + e$4.path,
                          message: e$4.message,
                          value: e$4.value
                        }
                      };
              }
              var e$5 = defaultPrevented._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".defaultPrevented" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                      }
                    };
            }
            var e$6 = currentTarget._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".currentTarget" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = composed._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".composed" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
        }
        var e$8 = cancelable._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".cancelable" + e$8.path,
                  message: e$8.message,
                  value: e$8.value
                }
              };
      }
      var e$9 = bubbles._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".bubbles" + e$9.path,
                message: e$9.message,
                value: e$9.value
              }
            };
    }
    var e$10 = detail._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".detail" + e$10.path,
              message: e$10.message,
              value: e$10.value
            }
          };
  }
  var e$11 = relatedTarget._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".relatedTarget" + e$11.path,
            message: e$11.message,
            value: e$11.value
          }
        };
}

function fromDomFocusEvent($$event) {
  return {
          relatedTarget: OptionUtils$SmartcutsMacros.$neg$question$great(Caml_option.nullable_to_opt($$event.relatedTarget), fromDomEventTarget),
          detail: $$event.detail,
          bubbles: $$event.bubbles,
          cancelable: $$event.cancelable,
          composed: $$event.composed,
          currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
          defaultPrevented: $$event.defaultPrevented,
          eventPhase: Curry._1(Webapi__Dom__FocusEvent.eventPhase, $$event),
          target: fromDomEventTarget($$event.target),
          timeStamp: $$event.timeStamp,
          type_: $$event.type,
          isTrusted: $$event.isTrusted
        };
}

function stringify$9($$event) {
  return JSON.stringify(t_encode$9($$event));
}

var FocusEventForSerialization = {
  t_encode: t_encode$9,
  t_decode: t_decode$9,
  fromDomFocusEvent: fromDomFocusEvent,
  stringify: stringify$9
};

function deltaMode_encode(v) {
  switch (v) {
    case /* Pixel */0 :
        return ["Pixel"];
    case /* Line */1 :
        return ["Line"];
    case /* Page */2 :
        return ["Page"];
    
  }
}

function deltaMode_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Line" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Line */1
                  };
          }
      case "Page" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Page */2
                  };
          }
      case "Pixel" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Pixel */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function webapiDeltaModeToDeltaMode(webapiDeltaMode) {
  return webapiDeltaMode;
}

function t_encode$10(v) {
  return Js_dict.fromArray([
              [
                "deltaX",
                Decco.floatToJson(v.deltaX)
              ],
              [
                "deltaY",
                Decco.floatToJson(v.deltaY)
              ],
              [
                "deltaZ",
                Decco.floatToJson(v.deltaZ)
              ],
              [
                "deltaMode",
                deltaMode_encode(v.deltaMode)
              ],
              [
                "altKey",
                Decco.boolToJson(v.altKey)
              ],
              [
                "button",
                Decco.intToJson(v.button)
              ],
              [
                "buttons",
                Decco.intToJson(v.buttons)
              ],
              [
                "clientX",
                Decco.floatToJson(v.clientX)
              ],
              [
                "clientY",
                Decco.floatToJson(v.clientY)
              ],
              [
                "ctrlKey",
                Decco.boolToJson(v.ctrlKey)
              ],
              [
                "metaKey",
                Decco.boolToJson(v.metaKey)
              ],
              [
                "movementX",
                Decco.intToJson(v.movementX)
              ],
              [
                "movementY",
                Decco.intToJson(v.movementY)
              ],
              [
                "offsetX",
                Decco.intToJson(v.offsetX)
              ],
              [
                "offsetY",
                Decco.intToJson(v.offsetY)
              ],
              [
                "pageX",
                Decco.intToJson(v.pageX)
              ],
              [
                "pageY",
                Decco.intToJson(v.pageY)
              ],
              [
                "region",
                Decco.optionToJson(Decco.stringToJson, v.region)
              ],
              [
                "relatedTarget",
                Decco.optionToJson(t_encode, v.relatedTarget)
              ],
              [
                "screenX",
                Decco.intToJson(v.screenX)
              ],
              [
                "screenY",
                Decco.intToJson(v.screenY)
              ],
              [
                "shiftKey",
                Decco.boolToJson(v.shiftKey)
              ],
              [
                "x",
                Decco.intToJson(v.x)
              ],
              [
                "y",
                Decco.intToJson(v.y)
              ],
              [
                "detail",
                Decco.intToJson(v.detail)
              ],
              [
                "bubbles",
                Decco.boolToJson(v.bubbles)
              ],
              [
                "cancelable",
                Decco.boolToJson(v.cancelable)
              ],
              [
                "composed",
                Decco.boolToJson(v.composed)
              ],
              [
                "currentTarget",
                Decco.optionToJson(t_encode, v.currentTarget)
              ],
              [
                "defaultPrevented",
                Decco.boolToJson(v.defaultPrevented)
              ],
              [
                "eventPhase",
                eventPhase_encode(v.eventPhase)
              ],
              [
                "target",
                t_encode(v.target)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ],
              [
                "type_",
                Decco.stringToJson(v.type_)
              ],
              [
                "isTrusted",
                Decco.boolToJson(v.isTrusted)
              ]
            ]);
}

function t_decode$10(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var deltaX = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deltaX"), null));
  if (deltaX.TAG === /* Ok */0) {
    var deltaY = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deltaY"), null));
    if (deltaY.TAG === /* Ok */0) {
      var deltaZ = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deltaZ"), null));
      if (deltaZ.TAG === /* Ok */0) {
        var deltaMode = deltaMode_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deltaMode"), null));
        if (deltaMode.TAG === /* Ok */0) {
          var altKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "altKey"), null));
          if (altKey.TAG === /* Ok */0) {
            var button = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "button"), null));
            if (button.TAG === /* Ok */0) {
              var buttons = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "buttons"), null));
              if (buttons.TAG === /* Ok */0) {
                var clientX = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientX"), null));
                if (clientX.TAG === /* Ok */0) {
                  var clientY = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientY"), null));
                  if (clientY.TAG === /* Ok */0) {
                    var ctrlKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ctrlKey"), null));
                    if (ctrlKey.TAG === /* Ok */0) {
                      var metaKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metaKey"), null));
                      if (metaKey.TAG === /* Ok */0) {
                        var movementX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "movementX"), null));
                        if (movementX.TAG === /* Ok */0) {
                          var movementY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "movementY"), null));
                          if (movementY.TAG === /* Ok */0) {
                            var offsetX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offsetX"), null));
                            if (offsetX.TAG === /* Ok */0) {
                              var offsetY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offsetY"), null));
                              if (offsetY.TAG === /* Ok */0) {
                                var pageX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageX"), null));
                                if (pageX.TAG === /* Ok */0) {
                                  var pageY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageY"), null));
                                  if (pageY.TAG === /* Ok */0) {
                                    var region = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "region"), null));
                                    if (region.TAG === /* Ok */0) {
                                      var relatedTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "relatedTarget"), null));
                                      if (relatedTarget.TAG === /* Ok */0) {
                                        var screenX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenX"), null));
                                        if (screenX.TAG === /* Ok */0) {
                                          var screenY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenY"), null));
                                          if (screenY.TAG === /* Ok */0) {
                                            var shiftKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "shiftKey"), null));
                                            if (shiftKey.TAG === /* Ok */0) {
                                              var x = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "x"), null));
                                              if (x.TAG === /* Ok */0) {
                                                var y = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "y"), null));
                                                if (y.TAG === /* Ok */0) {
                                                  var detail = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
                                                  if (detail.TAG === /* Ok */0) {
                                                    var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
                                                    if (bubbles.TAG === /* Ok */0) {
                                                      var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
                                                      if (cancelable.TAG === /* Ok */0) {
                                                        var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
                                                        if (composed.TAG === /* Ok */0) {
                                                          var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
                                                          if (currentTarget.TAG === /* Ok */0) {
                                                            var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                                                            if (defaultPrevented.TAG === /* Ok */0) {
                                                              var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                                                              if (eventPhase.TAG === /* Ok */0) {
                                                                var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                                                                if (target.TAG === /* Ok */0) {
                                                                  var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                                                  if (timeStamp.TAG === /* Ok */0) {
                                                                    var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                                                                    if (type_.TAG === /* Ok */0) {
                                                                      var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                                                                      if (isTrusted.TAG === /* Ok */0) {
                                                                        return {
                                                                                TAG: /* Ok */0,
                                                                                _0: {
                                                                                  deltaX: deltaX._0,
                                                                                  deltaY: deltaY._0,
                                                                                  deltaZ: deltaZ._0,
                                                                                  deltaMode: deltaMode._0,
                                                                                  altKey: altKey._0,
                                                                                  button: button._0,
                                                                                  buttons: buttons._0,
                                                                                  clientX: clientX._0,
                                                                                  clientY: clientY._0,
                                                                                  ctrlKey: ctrlKey._0,
                                                                                  metaKey: metaKey._0,
                                                                                  movementX: movementX._0,
                                                                                  movementY: movementY._0,
                                                                                  offsetX: offsetX._0,
                                                                                  offsetY: offsetY._0,
                                                                                  pageX: pageX._0,
                                                                                  pageY: pageY._0,
                                                                                  region: region._0,
                                                                                  relatedTarget: relatedTarget._0,
                                                                                  screenX: screenX._0,
                                                                                  screenY: screenY._0,
                                                                                  shiftKey: shiftKey._0,
                                                                                  x: x._0,
                                                                                  y: y._0,
                                                                                  detail: detail._0,
                                                                                  bubbles: bubbles._0,
                                                                                  cancelable: cancelable._0,
                                                                                  composed: composed._0,
                                                                                  currentTarget: currentTarget._0,
                                                                                  defaultPrevented: defaultPrevented._0,
                                                                                  eventPhase: eventPhase._0,
                                                                                  target: target._0,
                                                                                  timeStamp: timeStamp._0,
                                                                                  type_: type_._0,
                                                                                  isTrusted: isTrusted._0
                                                                                }
                                                                              };
                                                                      }
                                                                      var e = isTrusted._0;
                                                                      return {
                                                                              TAG: /* Error */1,
                                                                              _0: {
                                                                                path: ".isTrusted" + e.path,
                                                                                message: e.message,
                                                                                value: e.value
                                                                              }
                                                                            };
                                                                    }
                                                                    var e$1 = type_._0;
                                                                    return {
                                                                            TAG: /* Error */1,
                                                                            _0: {
                                                                              path: ".type_" + e$1.path,
                                                                              message: e$1.message,
                                                                              value: e$1.value
                                                                            }
                                                                          };
                                                                  }
                                                                  var e$2 = timeStamp._0;
                                                                  return {
                                                                          TAG: /* Error */1,
                                                                          _0: {
                                                                            path: ".timeStamp" + e$2.path,
                                                                            message: e$2.message,
                                                                            value: e$2.value
                                                                          }
                                                                        };
                                                                }
                                                                var e$3 = target._0;
                                                                return {
                                                                        TAG: /* Error */1,
                                                                        _0: {
                                                                          path: ".target" + e$3.path,
                                                                          message: e$3.message,
                                                                          value: e$3.value
                                                                        }
                                                                      };
                                                              }
                                                              var e$4 = eventPhase._0;
                                                              return {
                                                                      TAG: /* Error */1,
                                                                      _0: {
                                                                        path: ".eventPhase" + e$4.path,
                                                                        message: e$4.message,
                                                                        value: e$4.value
                                                                      }
                                                                    };
                                                            }
                                                            var e$5 = defaultPrevented._0;
                                                            return {
                                                                    TAG: /* Error */1,
                                                                    _0: {
                                                                      path: ".defaultPrevented" + e$5.path,
                                                                      message: e$5.message,
                                                                      value: e$5.value
                                                                    }
                                                                  };
                                                          }
                                                          var e$6 = currentTarget._0;
                                                          return {
                                                                  TAG: /* Error */1,
                                                                  _0: {
                                                                    path: ".currentTarget" + e$6.path,
                                                                    message: e$6.message,
                                                                    value: e$6.value
                                                                  }
                                                                };
                                                        }
                                                        var e$7 = composed._0;
                                                        return {
                                                                TAG: /* Error */1,
                                                                _0: {
                                                                  path: ".composed" + e$7.path,
                                                                  message: e$7.message,
                                                                  value: e$7.value
                                                                }
                                                              };
                                                      }
                                                      var e$8 = cancelable._0;
                                                      return {
                                                              TAG: /* Error */1,
                                                              _0: {
                                                                path: ".cancelable" + e$8.path,
                                                                message: e$8.message,
                                                                value: e$8.value
                                                              }
                                                            };
                                                    }
                                                    var e$9 = bubbles._0;
                                                    return {
                                                            TAG: /* Error */1,
                                                            _0: {
                                                              path: ".bubbles" + e$9.path,
                                                              message: e$9.message,
                                                              value: e$9.value
                                                            }
                                                          };
                                                  }
                                                  var e$10 = detail._0;
                                                  return {
                                                          TAG: /* Error */1,
                                                          _0: {
                                                            path: ".detail" + e$10.path,
                                                            message: e$10.message,
                                                            value: e$10.value
                                                          }
                                                        };
                                                }
                                                var e$11 = y._0;
                                                return {
                                                        TAG: /* Error */1,
                                                        _0: {
                                                          path: ".y" + e$11.path,
                                                          message: e$11.message,
                                                          value: e$11.value
                                                        }
                                                      };
                                              }
                                              var e$12 = x._0;
                                              return {
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        path: ".x" + e$12.path,
                                                        message: e$12.message,
                                                        value: e$12.value
                                                      }
                                                    };
                                            }
                                            var e$13 = shiftKey._0;
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      path: ".shiftKey" + e$13.path,
                                                      message: e$13.message,
                                                      value: e$13.value
                                                    }
                                                  };
                                          }
                                          var e$14 = screenY._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".screenY" + e$14.path,
                                                    message: e$14.message,
                                                    value: e$14.value
                                                  }
                                                };
                                        }
                                        var e$15 = screenX._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".screenX" + e$15.path,
                                                  message: e$15.message,
                                                  value: e$15.value
                                                }
                                              };
                                      }
                                      var e$16 = relatedTarget._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".relatedTarget" + e$16.path,
                                                message: e$16.message,
                                                value: e$16.value
                                              }
                                            };
                                    }
                                    var e$17 = region._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".region" + e$17.path,
                                              message: e$17.message,
                                              value: e$17.value
                                            }
                                          };
                                  }
                                  var e$18 = pageY._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".pageY" + e$18.path,
                                            message: e$18.message,
                                            value: e$18.value
                                          }
                                        };
                                }
                                var e$19 = pageX._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".pageX" + e$19.path,
                                          message: e$19.message,
                                          value: e$19.value
                                        }
                                      };
                              }
                              var e$20 = offsetY._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".offsetY" + e$20.path,
                                        message: e$20.message,
                                        value: e$20.value
                                      }
                                    };
                            }
                            var e$21 = offsetX._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".offsetX" + e$21.path,
                                      message: e$21.message,
                                      value: e$21.value
                                    }
                                  };
                          }
                          var e$22 = movementY._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".movementY" + e$22.path,
                                    message: e$22.message,
                                    value: e$22.value
                                  }
                                };
                        }
                        var e$23 = movementX._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".movementX" + e$23.path,
                                  message: e$23.message,
                                  value: e$23.value
                                }
                              };
                      }
                      var e$24 = metaKey._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".metaKey" + e$24.path,
                                message: e$24.message,
                                value: e$24.value
                              }
                            };
                    }
                    var e$25 = ctrlKey._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".ctrlKey" + e$25.path,
                              message: e$25.message,
                              value: e$25.value
                            }
                          };
                  }
                  var e$26 = clientY._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".clientY" + e$26.path,
                            message: e$26.message,
                            value: e$26.value
                          }
                        };
                }
                var e$27 = clientX._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".clientX" + e$27.path,
                          message: e$27.message,
                          value: e$27.value
                        }
                      };
              }
              var e$28 = buttons._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".buttons" + e$28.path,
                        message: e$28.message,
                        value: e$28.value
                      }
                    };
            }
            var e$29 = button._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".button" + e$29.path,
                      message: e$29.message,
                      value: e$29.value
                    }
                  };
          }
          var e$30 = altKey._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".altKey" + e$30.path,
                    message: e$30.message,
                    value: e$30.value
                  }
                };
        }
        var e$31 = deltaMode._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".deltaMode" + e$31.path,
                  message: e$31.message,
                  value: e$31.value
                }
              };
      }
      var e$32 = deltaZ._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".deltaZ" + e$32.path,
                message: e$32.message,
                value: e$32.value
              }
            };
    }
    var e$33 = deltaY._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".deltaY" + e$33.path,
              message: e$33.message,
              value: e$33.value
            }
          };
  }
  var e$34 = deltaX._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".deltaX" + e$34.path,
            message: e$34.message,
            value: e$34.value
          }
        };
}

function fromDomWheelEvent($$event) {
  return {
          deltaX: $$event.deltaX,
          deltaY: $$event.deltaY,
          deltaZ: $$event.deltaZ,
          deltaMode: Webapi__Dom__WheelEvent.deltaMode($$event),
          altKey: $$event.altKey,
          button: $$event.button,
          buttons: $$event.buttons,
          clientX: $$event.clientX,
          clientY: $$event.clientY,
          ctrlKey: $$event.ctrlKey,
          metaKey: $$event.metaKey,
          movementX: $$event.movementX,
          movementY: $$event.movementY,
          offsetX: $$event.offsetX,
          offsetY: $$event.offsetY,
          pageX: $$event.pageX,
          pageY: $$event.pageY,
          region: Caml_option.nullable_to_opt($$event.region),
          relatedTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.relatedTarget), fromDomEventTarget),
          screenX: $$event.screenX,
          screenY: $$event.screenY,
          shiftKey: $$event.shiftKey,
          x: $$event.x,
          y: $$event.y,
          detail: $$event.detail,
          bubbles: $$event.bubbles,
          cancelable: $$event.cancelable,
          composed: $$event.composed,
          currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
          defaultPrevented: $$event.defaultPrevented,
          eventPhase: Curry._1(Webapi__Dom__WheelEvent.eventPhase, $$event),
          target: fromDomEventTarget($$event.target),
          timeStamp: $$event.timeStamp,
          type_: $$event.type,
          isTrusted: $$event.isTrusted
        };
}

function stringify$10($$event) {
  return JSON.stringify(t_encode$10($$event));
}

var WheelEventForSerialization = {
  deltaMode_encode: deltaMode_encode,
  deltaMode_decode: deltaMode_decode,
  webapiDeltaModeToDeltaMode: webapiDeltaModeToDeltaMode,
  t_encode: t_encode$10,
  t_decode: t_decode$10,
  fromDomWheelEvent: fromDomWheelEvent,
  stringify: stringify$10
};

function t__encode(v) {
  switch (v.TAG | 0) {
    case /* MouseEvent */0 :
        return [
                "MouseEvent",
                Decco.stringToJson(v._0),
                t_encode$4(v._1)
              ];
    case /* InputEvent */1 :
        return [
                "InputEvent",
                Decco.stringToJson(v._0),
                t_encode$5(v._1)
              ];
    case /* KeyboardEvent */2 :
        return [
                "KeyboardEvent",
                Decco.stringToJson(v._0),
                t_encode$6(v._1)
              ];
    case /* ClipboardEvent */3 :
        return [
                "ClipboardEvent",
                Decco.stringToJson(v._0),
                t_encode$7(v._1)
              ];
    case /* DragEvent */4 :
        return [
                "DragEvent",
                Decco.stringToJson(v._0),
                t_encode$8(v._1)
              ];
    case /* WheelEvent */5 :
        return [
                "WheelEvent",
                Decco.stringToJson(v._0),
                t_encode$10(v._1)
              ];
    case /* FocusEvent */6 :
        return [
                "FocusEvent",
                Decco.stringToJson(v._0),
                t_encode$9(v._1)
              ];
    case /* BlurEvent */7 :
        return [
                "BlurEvent",
                Decco.stringToJson(v._0),
                t_encode$9(v._1)
              ];
    case /* ChangeEvent */8 :
        return [
                "ChangeEvent",
                t_encode$1(v._0),
                Decco.stringToJson(v._1)
              ];
    case /* Event */9 :
        return [
                "Event",
                Decco.stringToJson(v._0),
                t_encode$1(v._1)
              ];
    case /* SyntheticEvent */10 :
        return [
                "SyntheticEvent",
                t_encode$3(v._0)
              ];
    
  }
}

function t__decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BlurEvent" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = t_decode$9(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* BlurEvent */7,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ChangeEvent" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ChangeEvent */8,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$2 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "ClipboardEvent" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = t_decode$7(Belt_Array.getExn(jsonArr$1, 2));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ClipboardEvent */3,
                        _0: match$5._0,
                        _1: match$6._0
                      }
                    };
            }
            var e$4 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "DragEvent" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$7 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$8 = t_decode$8(Belt_Array.getExn(jsonArr$1, 2));
          if (match$7.TAG === /* Ok */0) {
            if (match$8.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* DragEvent */4,
                        _0: match$7._0,
                        _1: match$8._0
                      }
                    };
            }
            var e$6 = match$8._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = match$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "Event" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$9 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$10 = t_decode$1(Belt_Array.getExn(jsonArr$1, 2));
          if (match$9.TAG === /* Ok */0) {
            if (match$10.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Event */9,
                        _0: match$9._0,
                        _1: match$10._0
                      }
                    };
            }
            var e$8 = match$10._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$8.path,
                      message: e$8.message,
                      value: e$8.value
                    }
                  };
          }
          var e$9 = match$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "FocusEvent" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$11 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$12 = t_decode$9(Belt_Array.getExn(jsonArr$1, 2));
          if (match$11.TAG === /* Ok */0) {
            if (match$12.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FocusEvent */6,
                        _0: match$11._0,
                        _1: match$12._0
                      }
                    };
            }
            var e$10 = match$12._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$10.path,
                      message: e$10.message,
                      value: e$10.value
                    }
                  };
          }
          var e$11 = match$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "InputEvent" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$13 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$14 = t_decode$5(Belt_Array.getExn(jsonArr$1, 2));
          if (match$13.TAG === /* Ok */0) {
            if (match$14.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* InputEvent */1,
                        _0: match$13._0,
                        _1: match$14._0
                      }
                    };
            }
            var e$12 = match$14._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$12.path,
                      message: e$12.message,
                      value: e$12.value
                    }
                  };
          }
          var e$13 = match$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "KeyboardEvent" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$15 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$16 = t_decode$6(Belt_Array.getExn(jsonArr$1, 2));
          if (match$15.TAG === /* Ok */0) {
            if (match$16.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* KeyboardEvent */2,
                        _0: match$15._0,
                        _1: match$16._0
                      }
                    };
            }
            var e$14 = match$16._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$14.path,
                      message: e$14.message,
                      value: e$14.value
                    }
                  };
          }
          var e$15 = match$15._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      case "MouseEvent" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$17 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$18 = t_decode$4(Belt_Array.getExn(jsonArr$1, 2));
          if (match$17.TAG === /* Ok */0) {
            if (match$18.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* MouseEvent */0,
                        _0: match$17._0,
                        _1: match$18._0
                      }
                    };
            }
            var e$16 = match$18._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$16.path,
                      message: e$16.message,
                      value: e$16.value
                    }
                  };
          }
          var e$17 = match$17._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "SyntheticEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$3(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SyntheticEvent */10,
                      _0: v0._0
                    }
                  };
          }
          var e$18 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
      case "WheelEvent" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$19 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$20 = t_decode$10(Belt_Array.getExn(jsonArr$1, 2));
          if (match$19.TAG === /* Ok */0) {
            if (match$20.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* WheelEvent */5,
                        _0: match$19._0,
                        _1: match$20._0
                      }
                    };
            }
            var e$19 = match$20._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$19.path,
                      message: e$19.message,
                      value: e$19.value
                    }
                  };
          }
          var e$20 = match$19._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function make($$event) {
  switch ($$event.TAG | 0) {
    case /* MouseEvent */0 :
        return {
                TAG: /* MouseEvent */0,
                _0: DOM__EventType$SmartcutsMacros.mouseToJs($$event._0),
                _1: fromDomMouseEvent($$event._1)
              };
    case /* InputEvent */1 :
        return {
                TAG: /* InputEvent */1,
                _0: DOM__EventType$SmartcutsMacros.inputToJs($$event._0),
                _1: fromDomInputEvent($$event._1)
              };
    case /* KeyboardEvent */2 :
        return {
                TAG: /* KeyboardEvent */2,
                _0: DOM__EventType$SmartcutsMacros.keyboardToJs($$event._0),
                _1: fromDomKeyboardEvent($$event._1)
              };
    case /* ClipboardEvent */3 :
        return {
                TAG: /* ClipboardEvent */3,
                _0: DOM__EventType$SmartcutsMacros.clipboardToJs($$event._0),
                _1: fromDomClipboardEvent($$event._1)
              };
    case /* DragEvent */4 :
        return {
                TAG: /* DragEvent */4,
                _0: DOM__EventType$SmartcutsMacros.dragToJs($$event._0),
                _1: fromDomDragEvent($$event._1)
              };
    case /* WheelEvent */5 :
        return {
                TAG: /* WheelEvent */5,
                _0: DOM__EventType$SmartcutsMacros.wheelToJs($$event._0),
                _1: fromDomWheelEvent($$event._1)
              };
    case /* FocusEvent */6 :
        return {
                TAG: /* FocusEvent */6,
                _0: DOM__EventType$SmartcutsMacros.focusToJs($$event._0),
                _1: fromDomFocusEvent($$event._1)
              };
    case /* BlurEvent */7 :
        return {
                TAG: /* BlurEvent */7,
                _0: DOM__EventType$SmartcutsMacros.blurToJs($$event._0),
                _1: fromDomFocusEvent($$event._1)
              };
    case /* ChangeEvent */8 :
        return {
                TAG: /* ChangeEvent */8,
                _0: fromDomEvent($$event._0),
                _1: $$event._1
              };
    case /* Event */9 :
        return {
                TAG: /* Event */9,
                _0: DOM__EventType$SmartcutsMacros.tToJs($$event._0),
                _1: fromDomEvent($$event._1)
              };
    case /* SyntheticEvent */10 :
        return {
                TAG: /* SyntheticEvent */10,
                _0: fromSyntheticEvent($$event._0)
              };
    
  }
}

function stringify$11($$event) {
  switch ($$event.TAG | 0) {
    case /* MouseEvent */0 :
        return "MouseEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$4($$event._1)) + ")")));
    case /* InputEvent */1 :
        return "InputEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$5($$event._1)) + ")")));
    case /* KeyboardEvent */2 :
        return "KeyboardEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$6($$event._1)) + ")")));
    case /* ClipboardEvent */3 :
        return "ClipboardEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$7($$event._1)) + ")")));
    case /* DragEvent */4 :
        return "DragEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$8($$event._1)) + ")")));
    case /* WheelEvent */5 :
        return "WheelEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$10($$event._1)) + ")")));
    case /* FocusEvent */6 :
        return "FocusEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$9($$event._1)) + ")")));
    case /* BlurEvent */7 :
        return "BlurEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$9($$event._1)) + ")")));
    case /* ChangeEvent */8 :
        return "ChangeEvent(" + (JSON.stringify(t_encode$1($$event._0)) + (", " + (StringUtils$SmartcutsMacros.quote($$event._1) + ")")));
    case /* Event */9 :
        return "Event(" + ($$event._0 + (", " + (JSON.stringify(t_encode$1($$event._1)) + ")")));
    case /* SyntheticEvent */10 :
        return "SyntheticEvent(" + stringify$3($$event._0);
    
  }
}

exports.EventTargetForSerialization = EventTargetForSerialization;
exports.eventPhase_encode = eventPhase_encode;
exports.eventPhase_decode = eventPhase_decode;
exports.webapiEventPhaseToEventPhase = webapiEventPhaseToEventPhase;
exports.EventForSerialization = EventForSerialization;
exports.SyntheticEventForSerialization = SyntheticEventForSerialization;
exports.MouseEventForSerialization = MouseEventForSerialization;
exports.InputEventForSerialization = InputEventForSerialization;
exports.KeyboardEventForSerialization = KeyboardEventForSerialization;
exports.ClipboardEventForSerialization = ClipboardEventForSerialization;
exports.DragEventForSerialization = DragEventForSerialization;
exports.FocusEventForSerialization = FocusEventForSerialization;
exports.WheelEventForSerialization = WheelEventForSerialization;
exports.t__encode = t__encode;
exports.t__decode = t__decode;
exports.make = make;
exports.stringify = stringify$11;
/* Webapi__Dom__DragEvent Not a pure module */
